export default __webpack_public_path__ + "static/media/medical-colleges.80201a11.png";